import { GenericButton } from './GenericButton';
import { Button as ButtonType } from '@/schemas/sceneDataSchema';
import { Icon } from '@mui/material';
import type { MouseEventHandler } from 'react';

interface ComponentButtonProps {
  component: ButtonType;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  form?: string;
  href?: string;
  type?: 'submit' | 'reset' | 'button';
  asComponent?: 'button' | 'a';
  loading?: boolean;
}

export const ComponentButton = ({
  component,
  onClick,
  type,
  form,
  href,
  asComponent = 'button',
  loading = false,
}: ComponentButtonProps) => {
  return (
    <GenericButton
      form={form}
      href={href}
      onClick={onClick}
      id={component.id}
      label={component.label}
      startIcon={component.start_icon && <Icon>{component.start_icon}</Icon>}
      endIcon={component.end_icon && <Icon>{component.end_icon}</Icon>}
      color={component.color}
      type={type}
      variant={component.variant}
      size={component.size}
      component={asComponent}
      fullWidth={component.full_width ?? true}
      loading={loading}
    />
  );
};
